var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "brand__section" }, [
      _c("div", { staticClass: "brand__container" }, [
        _c("div", { staticClass: "brand__item" }, [
          _c("img", {
            staticClass: "lazy",
            attrs: {
              "data-srcset":
                "https://cdn.flixel.com/static/static-web/brands/antm@2x.png 2x, https://cdn.flixel.com/static/static-web/brands/antm.png 1x"
            }
          })
        ]),
        _c("div", { staticClass: "brand__item" }, [
          _c("img", {
            staticClass: "lazy",
            attrs: {
              "data-srcset":
                "https://cdn.flixel.com/static/static-web/brands/bbdo@2x.png 2x, https://cdn.flixel.com/static/static-web/brands/bbdo.png 1x"
            }
          })
        ]),
        _c("div", { staticClass: "brand__item" }, [
          _c("img", {
            staticClass: "lazy",
            attrs: {
              "data-srcset":
                "https://cdn.flixel.com/static/static-web/brands/espn@2x.png 2x, https://cdn.flixel.com/static/static-web/brands/espn.png 1x"
            }
          })
        ]),
        _c("div", { staticClass: "brand__item" }, [
          _c("img", {
            staticClass: "lazy",
            attrs: {
              "data-srcset":
                "https://cdn.flixel.com/static/static-web/brands/facebook@2x.png 2x, https://cdn.flixel.com/static/static-web/brands/facebook.png 1x"
            }
          })
        ]),
        _c("div", { staticClass: "brand__item" }, [
          _c("img", {
            staticClass: "lazy",
            attrs: {
              "data-srcset":
                "https://cdn.flixel.com/static/static-web/brands/hbo@2x.png 2x, https://cdn.flixel.com/static/static-web/brands/hbo.png 1x"
            }
          })
        ]),
        _c("div", { staticClass: "brand__item" }, [
          _c("img", {
            staticClass: "lazy",
            attrs: {
              "data-srcset":
                "https://cdn.flixel.com/static/static-web/brands/instagram@2x.png 2x, https://cdn.flixel.com/static/static-web/brands/instagram.png 1x"
            }
          })
        ]),
        _c("div", { staticClass: "brand__item" }, [
          _c("img", {
            staticClass: "lazy",
            attrs: {
              "data-srcset":
                "https://cdn.flixel.com/static/static-web/brands/lincoln@2x.png 2x, https://cdn.flixel.com/static/static-web/brands/lincoln.png 1x"
            }
          })
        ]),
        _c("div", { staticClass: "brand__item" }, [
          _c("img", {
            staticClass: "lazy",
            attrs: {
              "data-srcset":
                "https://cdn.flixel.com/static/static-web/brands/marriott@2x.png 2x, https://cdn.flixel.com/static/static-web/brands/marriott.png 1x"
            }
          })
        ]),
        _c("div", { staticClass: "brand__item" }, [
          _c("img", {
            staticClass: "lazy",
            attrs: {
              "data-srcset":
                "https://cdn.flixel.com/static/static-web/brands/mashable@2x.png 2x, https://cdn.flixel.com/static/static-web/brands/mashable.png 1x"
            }
          })
        ]),
        _c("div", { staticClass: "brand__item" }, [
          _c("img", {
            staticClass: "lazy",
            attrs: {
              "data-srcset":
                "https://cdn.flixel.com/static/static-web/brands/mccann@2x.png 2x, https://cdn.flixel.com/static/static-web/brands/mccann.png 1x"
            }
          })
        ]),
        _c("div", { staticClass: "brand__item" }, [
          _c("img", {
            staticClass: "lazy",
            attrs: {
              "data-srcset":
                "https://cdn.flixel.com/static/static-web/brands/mercedes@2x.png 2x, https://cdn.flixel.com/static/static-web/brands/mercedes.png 1x"
            }
          })
        ]),
        _c("div", { staticClass: "brand__item" }, [
          _c("img", {
            staticClass: "lazy",
            attrs: {
              "data-srcset":
                "https://cdn.flixel.com/static/static-web/brands/microsoft@2x.png 2x, https://cdn.flixel.com/static/static-web/brands/microsoft.png 1x"
            }
          })
        ]),
        _c("div", { staticClass: "brand__item" }, [
          _c("img", {
            staticClass: "lazy",
            attrs: {
              "data-srcset":
                "https://cdn.flixel.com/static/static-web/brands/panasonic@2x.png 2x, https://cdn.flixel.com/static/static-web/brands/panasonic.png 1x"
            }
          })
        ]),
        _c("div", { staticClass: "brand__item" }, [
          _c("img", {
            staticClass: "lazy",
            attrs: {
              "data-srcset":
                "https://cdn.flixel.com/static/static-web/brands/pepsi@2x.png 2x, https://cdn.flixel.com/static/static-web/brands/pepsi.png 1x"
            }
          })
        ]),
        _c("div", { staticClass: "brand__item" }, [
          _c("img", {
            staticClass: "lazy",
            attrs: {
              "data-srcset":
                "https://cdn.flixel.com/static/static-web/brands/ted@2x.png 2x, https://cdn.flixel.com/static/static-web/brands/ted.png 1x"
            }
          })
        ])
      ]),
      _c("div", { staticClass: "marketingBadge" }, [
        _c(
          "a",
          {
            attrs: {
              href:
                "https://www.facebook.com/business/solutions-explorer/creative_platform/2160199024257586/Flixel"
            }
          },
          [
            _c("img", {
              staticClass: "lazy",
              attrs: {
                "data-srcset":
                  "https://cdn.flixel.com/static/static-web/brands/fbMarketing@2x.png 2x, https://cdn.flixel.com/static/static-web/brands/fbMarketing.png 1x",
                alt: "Facebook Marketing Partner"
              }
            })
          ]
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3ef605fc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ef605fc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Brands.vue
// module id = null
// module chunks = 